import { render, staticRenderFns } from "./dash-stat-tabs.vue?vue&type=template&id=7e4acffe&scoped=true"
import script from "./dash-stat-tabs.vue?vue&type=script&lang=js"
export * from "./dash-stat-tabs.vue?vue&type=script&lang=js"
import style0 from "./dash-stat-tabs.vue?vue&type=style&index=0&id=7e4acffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4acffe",
  null
  
)

export default component.exports